module.exports = __webpack_public_path__ + "static/media/EB_Logo_white_text.54a3bdc2.svg";